import request from './request';
import {ISensor} from 'model/waterStation';

export const getSensors = (type: 'chemical' | 'pressure') =>
  request.request<ISensor[]>({
    url: `/sensors/?type=${type}`,
    method: 'GET',
  });
